
import wx from 'weixin-js-sdk'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import defautphoto from '@/assets/timg.jpg'
import config from '@/config'
import { getUserAccount, updateUserAccount } from '@/api/user.js'
import { getConfig, addFile } from '@/api/wx.js'
import { getSex } from '@/api/sys.js'
import store from '@/store'
import addressPicker from '@/views/components/address-picker'
export default {
name: 'userinfo',
components: {
Group,
Cell,
addressPicker,
XInput,
PopupRadio,
XButton,
PopupPicker
},
data () {
return {
defautphoto: defautphoto,
baseUrl: config.baseUrl,
photo: '',
photoID: '',
personObj: {
idcard: '',
acctname: '',
mobile: '',
unitname: '',
accountsexid: '',
birthday: '',
iconimgPATH: '',
provinceidNAME: '',
cityidNAME: '',
countyidNAME: '',
provinceid: '',
cityid: '',
countyid: ''
},
integral: '',
address: '',
addressValue: ['31', '', ''],
sexList: [],
sexValue: ['1'],
photoObj: {
title: '头像',
maxnum: 1,
imglist: [],
imgcount: 1,
fileList: { fileUrlArr: [], fileIdArr: [] }
},
area: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
watch: {
sexValue (newVal, oldVal) {
this.personObj.accountsexid = newVal[0]
},
addressValue: {
handler: function (val) {
this.personObj.provinceid = val[0]
this.personObj.cityid = val[1]
this.personObj.countyid = val[2]
},
deep: true
}
},
methods: {

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, filelist, imgcount) {

var _this = this
wx.chooseImage({
count: _this.photoObj.imgcount, // 默认5
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this.photoObj.imgcount = _this.photoObj.imgcount - localIds.length
_this.uploadFile(imglist, filelist, localIds)
}
}
})
},

uploadFile (imglist, filelist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
this.photoID = re.returnValue.id
filelist.fileUrlArr.push(config.baseUrl + re.returnValue.filepath)
filelist.fileIdArr.push(re.returnValue.id)
})
_this.index++
_this.uploadFile(imglist, filelist, localIds)
}
})
},

preview (index, filelist) {
var _this = this
wx.previewImage({
current: filelist.fileUrlArr[index], // 当前显示图片的http链接
urls: filelist.fileUrlArr 
})
},
getUserMessage () {
getUserAccount({
accountid: this.accountid
}).then(res => {
if (res.status === 'suc') {
this.personObj.idcard = res.returnValue.idcard
this.personObj.acctname = res.returnValue.acctname
this.personObj.mobile = res.returnValue.mobile
this.personObj.unitname = res.returnValue.unitname
this.sexValue[0] = res.returnValue.accountsexid
this.personObj.birthday = res.returnValue.birthday
this.personObj.iconimgPATH = res.returnValue.iconimgPATH
this.personObj.provinceidNAME = res.returnValue.provinceidNAME
this.personObj.cityidNAME = res.returnValue.cityidNAME
this.personObj.countyidNAME = res.returnValue.countyidNAME
this.photo = res.returnValue.iconimgPATH
this.photoID = res.returnValue.iconimg
}
})
},
getSexName () {
getSex({}).then(res => {
res.obj.forEach(item => {
if (item.key != '') {
this.sexList.push({
name: item.value,
value: item.key + ''
})
}
})
})
},
sumbit () {
if (this.personObj.accountsexid === '') {
this.personObj.accountsexid = this.$store.state.user.personObj.accountsexid
}
if (this.personObj.idcard.indexOf('*') != -1) {
this.personObj.idcard = ''
}
updateUserAccount({
accountid: this.accountid,
iconimg: this.photoID,
unitname: this.personObj.unitname,
idcard: this.personObj.idcard,
accountsexid: this.personObj.accountsexid,
provinceid: this.personObj.provinceid,
cityid: this.personObj.cityid,
countyid: this.personObj.countyid
}).then(res => {
if (res.status === 'suc') {
this.$vux.toast.text('修改成功！', 'middle')
this.$router.push({ path: '/userinfo' })
}
})
},
getBirthdayFromIdCard (idCard) {
let birthday = ''
if (idCard != null && idCard != '') {
if (idCard.length == 15) {
birthday = '19' + idCard.substr(6, 6)
} else if (idCard.length == 18) {
birthday = idCard.substr(6, 8)
}
birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
}
return birthday
}
},
created () {
this.wxconfig()

this.getSexName()
this.personObj = this.$store.state.user.personObj
let unitname = this.personObj.unitname
let areaList = ['杭州', '宁波', '温州', '嘉兴', '湖州', '绍兴', '金华', '衢州', '丽水', '台州', '舟山']
areaList.forEach(item => {
if (unitname.indexOf(item) > -1) {
this.area = item
} else {
this.area = '直属'
}
})
this.photo = this.$store.state.user.personObj.iconimgPATH
this.sexValue[0] = this.$store.state.user.personObj.accountsexid.toString()
if (this.$store.state.user.personObj.provinceid != '') {
this.$set(this.addressValue, 0, this.$store.state.user.personObj.provinceid)
this.$set(this.addressValue, 1, this.$store.state.user.personObj.cityid)
this.$set(this.addressValue, 2, this.$store.state.user.personObj.countyid)
}
},
mounted () { }
}
